import { configureStore } from "@reduxjs/toolkit";
import { profileReducer } from "./profile/slice";
import { socketReducer } from "./socket/slice";
import { profileAppearanceReducer } from "./profile-appearance/slice";
import { profileFormReducer } from "./profile-form/slice";
import { profileBusinessReducer } from "./profile-business/slice";
import { profileRouterReducer } from "./profile-router/slice";
import { profileShorthandReducer } from "./profile-shorthand/slice";
import { profileTriggerReducer } from "./profile-trigger/slice";
import { tokenReducer } from "./token/slice";
import { staffReducer } from "./staff/slice";
import { requesterReducer } from "./requester/slice";
import { messageReducer } from "./message/slice";
import { noteReducer } from "./note/slice";
import { attachmentReducer } from "./attachment/slice";
import { sessionReducer } from "./session/slice";
import { groupReducer } from "./group/slice";
import { staffStatsReducer } from "./staff-stats/slice";

export const store = configureStore({
  reducer: {
    profileManage: profileReducer,
    profileAppearanceManage: profileAppearanceReducer,
    profileBusinessManage: profileBusinessReducer,
    profileFormManage: profileFormReducer,
    profileRouterManage: profileRouterReducer,
    profileShorthandManage: profileShorthandReducer,
    profileTriggerManage: profileTriggerReducer,
    socketManage: socketReducer,
    tokenManage: tokenReducer,
    staffManage: staffReducer,
    requesterManage: requesterReducer,
    messageManage: messageReducer,
    attachmentManage: attachmentReducer,
    noteManage: noteReducer,
    sessionManage: sessionReducer,
    groupManage: groupReducer,
    staffStatsManage: staffStatsReducer,
  },
});
